import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PedidoServiceService {

  constructor(private http:HttpClient) { }

  @Output() emitOrderId: EventEmitter<any> = new EventEmitter();

 public obtenerPedidos(){
    return this.http.get(environment.API_SECURITY+'/api/Ordenes/ordenesCliente')
  }

  public rastrearPedido(id: number){
    return this.http.get(environment.API_SECURITY+'/api/Ordenes/rastreoOrden/'+id)
  }
  
  public cancelarOrden(id: number){
    return this.http.get(environment.API_SECURITY+'/api/Ordenes/cancelarOrden/'+id)
  }
}